(function () {
  var headerSelectionSequence = 0;
  function imageKey(src) {
    return String(src || '').split(/[?#]/)[0].split('/').pop()
      .replace(/_(?:\d+x\d*|\d*x\d+)(?=\.[a-z0-9]+$)/i, '');
  }

  function selectedProduct(product, selections, productByVariant) {
    for (var selection of selections) {
      var productId = productByVariant.get(String(selection.variantId));
      if (productId) {
        if (String(product.productId) === productId) return selection;
        continue;
      }
      if (product.title === selection.title && imageKey(product.image) &&
          imageKey(product.image) === imageKey(selection.image)) return selection;
    }
    return null;
  }

  function moneyValue(text, locale) {
    if (!text || !/\d/.test(text)) return NaN;
    var parts = new Intl.NumberFormat(locale).formatToParts(1234.5);
    var group = parts.find(function (part) { return part.type === 'group'; });
    var decimal = parts.find(function (part) { return part.type === 'decimal'; });
    var number = String(text);
    if (group) number = number.split(group.value).join('');
    if (decimal) number = number.split(decimal.value).join('.');
    return Number(number.replace(/[^\d.-]/g, ''));
  }

  function savingsAmount(original, current, locale) {
    var amount = Math.round((moneyValue(original, locale) - moneyValue(current, locale)) * 100) / 100;
    return Number.isFinite(amount) && amount > 0 ? amount : null;
  }

  function selectionProgress(slots) {
    var selected = slots.filter(function (slot) { return Boolean(slot.variantId); }).length;
    return { selected: selected, total: slots.length, remaining: slots.length - selected };
  }

  function fixedSizeLabel(selected, options) {
    return selected && options.length === 1 && /^size$/i.test(options[0].name) &&
      /^one size$/i.test(options[0].value.trim()) ? 'Size: One size' : null;
  }

  function selectionFacts(selection) {
    if (!selection) return [];
    var facts = [];
    if (selection.color) facts.push({
      label: /3[ -]?pack/i.test(selection.title || '') && /^fall uniform$/i.test(selection.color) ? 'Pack' : 'Color',
      value: selection.color,
    });
    if (selection.size) facts.push({ label: 'Size', value: /^one size$/i.test(selection.size.trim()) ? 'One size' : selection.size });
    return facts;
  }

  function renderHeaderSelection(summary, selections, header) {
    var identifier = summary.getAttribute('id');
    if (!identifier) {
      identifier = 'message-bundly-header-selection-' + (++headerSelectionSequence);
      summary.setAttribute('id', identifier);
    }
    // Preserve the app's button name and expansion semantics while exposing
    // the current choice as its accessible description.
    if (header && header.localName === 'button') {
      var descriptions = (header.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) {
        return id && !/^message-bundly-header-selection-/.test(id);
      });
      if (selections.length) descriptions.push(identifier);
      if (descriptions.length) header.setAttribute('aria-describedby', descriptions.join(' '));
      else header.removeAttribute('aria-describedby');
    }
    summary.hidden = !selections.length;
    var signature = JSON.stringify(selections.map(function (selection) { return [selection.title, selectionFacts(selection)]; }));
    if (summary.getAttribute('data-selection-signature') === signature) return;
    summary.setAttribute('data-selection-signature', signature);
    summary.replaceChildren();
    var doc = summary.ownerDocument;
    selections.forEach(function (selection) {
      var item = doc.createElement('span');
      item.className = 'message-bundly-header-selection-item';
      var title = doc.createElement('strong');
      title.className = 'message-bundly-header-selection-title';
      title.textContent = selection.title + ' ';
      item.appendChild(title);
      var facts = doc.createElement('span');
      facts.className = 'message-bundly-header-selection-facts';
      selectionFacts(selection).forEach(function (fact) {
        var pair = doc.createElement('span');
        var label = doc.createElement('span');
        label.textContent = fact.label + ': ';
        var value = doc.createElement('strong');
        value.textContent = fact.value + ' ';
        pair.appendChild(label);
        pair.appendChild(value);
        facts.appendChild(pair);
      });
      item.appendChild(facts);
      summary.appendChild(item);
    });
  }

  function renderCardSelection(status, selection) {
    var facts = selectionFacts(selection);
    var signature = JSON.stringify([Boolean(selection), facts]);
    status.hidden = !selection;
    if (status.getAttribute('data-selection-signature') === signature) return;
    status.setAttribute('data-selection-signature', signature);
    status.replaceChildren();
    if (!selection) return;
    var doc = status.ownerDocument;
    var heading = doc.createElement('p');
    heading.className = 'message-bundly-selected-label';
    heading.textContent = 'Selected';
    status.appendChild(heading);
    var list = doc.createElement('dl');
    list.className = 'message-bundly-selected-options';
    facts.forEach(function (fact) {
      var pair = doc.createElement('div');
      var name = doc.createElement('dt');
      name.textContent = fact.label;
      var value = doc.createElement('dd');
      value.textContent = fact.value;
      pair.appendChild(name);
      pair.appendChild(value);
      list.appendChild(pair);
    });
    status.appendChild(list);
  }

  function renderIncludedCount(card, quantity) {
    var badge = card.querySelector('.message-bundly-included-count');
    if (!badge && quantity) {
      var doc = card.ownerDocument;
      badge = doc.createElement('span');
      badge.className = 'bundly__component_count_badge message-bundly-included-count';
      var label = doc.createElement('span');
      label.setAttribute('data-item', 'hidden-text');
      label.textContent = 'Quantity included: ';
      badge.appendChild(label);
      var count = doc.createElement('span');
      count.className = 'bundly__component_count_badge_count';
      badge.appendChild(count);
      card.appendChild(badge);
    }
    if (badge) {
      badge.hidden = !quantity;
      var value = String(quantity);
      var count = badge.querySelector('.bundly__component_count_badge_count');
      if (count.textContent !== value) count.textContent = value;
    }
    return badge || null;
  }

  function mountCardSize(info, options) {
    var button = info.querySelector(':scope > .bundly__add_to_bundle_button');
    var label = fixedSizeLabel(Boolean(button), options);
    var caption = info.querySelector(':scope > .message-bundly-card-size');
    if (!caption && label) {
      caption = info.ownerDocument.createElement('p');
      caption.className = 'message-bundly-card-size message-bundly-fixed-size';
      info.insertBefore(caption, info.querySelector(':scope > .bundly__product_availability') || button);
    }
    if (caption) {
      caption.hidden = !label;
      if (label && caption.textContent !== label) caption.textContent = label;
    }
    return caption || null;
  }

  function placeCardNotes(info) {
    var button = info.querySelector(':scope > .bundly__choose_options_button, :scope > .bundly__add_to_bundle_button');
    if (!button) return;
    info.querySelectorAll(':scope > .message-bundly-card-status, :scope > .message-bundly-three-pack-note, :scope > .message-bundly-preorder').forEach(function (note) {
      var siblings = Array.from(info.children);
      if (siblings.indexOf(note) > siblings.indexOf(button)) info.insertBefore(note, button);
    });
  }

  function isRepeatedSelection(slots, selection) {
    return Boolean(selection.variantId) && slots.some(function (slot) {
      return String(slot.componentIndex) === String(selection.componentIndex) &&
        String(slot.componentVariantIndex) === String(selection.componentVariantIndex) &&
        String(slot.variantId) === String(selection.variantId);
    });
  }

  function mountSizeGuide(container, template) {
    var button = container.querySelector('.bundly__add_to_bundle_button');
    if (!button) return null;
    var guide = container.querySelector('.message-bundly-size-guide');
    if (!guide) {
      var doc = container.ownerDocument;
      guide = doc.createElement('details');
      guide.className = 'message-bundly-size-guide product-size-chart--inline';
      guide.open = true;
      var summary = doc.createElement('summary');
      summary.className = 'product-size-chart--summary';
      summary.setAttribute('data-item', 'block-link');
      summary.textContent = template.getAttribute('data-label');
      guide.appendChild(summary);
      var content = doc.createElement('div');
      content.className = 'product-size-chart--content';
      content.setAttribute('data-item', 'rte-content');
      content.appendChild(template.content.cloneNode(true));
      guide.appendChild(content);
    }
    // Keep the native button and its handlers in place; only move our guide.
    if (guide.previousElementSibling !== button) button.insertAdjacentElement('afterend', guide);
    return guide;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { selectedProduct: selectedProduct, savingsAmount: savingsAmount, selectionProgress: selectionProgress, isRepeatedSelection: isRepeatedSelection, mountSizeGuide: mountSizeGuide, fixedSizeLabel: fixedSizeLabel, placeCardNotes: placeCardNotes, mountCardSize: mountCardSize, selectionFacts: selectionFacts, renderCardSelection: renderCardSelection, renderIncludedCount: renderIncludedCount, renderHeaderSelection: renderHeaderSelection };
  }
  if (typeof document === 'undefined') return;

  var productByVariant = new Map();
  var enhanced = new WeakMap();
  var records = new Set();
  var discovery;
  var locale = document.documentElement.lang || 'en';

  function text(element) { return element ? element.textContent.trim() : ''; }
  function setText(element, value) {
    if (element.textContent !== value) element.textContent = value;
  }
  function ensure(parent, className, tag) {
    var element = parent.querySelector('.' + className);
    if (!element) {
      element = document.createElement(tag || 'div');
      element.className = className;
      parent.appendChild(element);
    }
    return element;
  }
  function readSlots(record) {
    return Array.from(record.details.querySelectorAll('bundly-slot')).map(function (slot) {
      var image = slot.querySelector('.bundly__slot_image img');
      return {
        element: slot,
        componentIndex: slot.getAttribute('data-component-index'),
        componentVariantIndex: slot.getAttribute('data-component-variant-index'),
        variantId: slot.getAttribute('data-variant-id'),
        title: text(slot.querySelector('.bundly__slot_product_title')),
        color: text(slot.querySelector('.bundly__slot_color')),
        size: text(slot.querySelector('.bundly__slot_variant_title')),
        image: image && image.getAttribute('src'),
      };
    });
  }

  function addSizeGuides(record) {
    var template = document.querySelector('template[data-message-bundly-size-guide]');
    if (!template) return;
    record.root.querySelectorAll('.bundly__product_option').forEach(function (option) {
      var card = option.closest('bundly-collection-component-card, bundly-product-component-card');
      var handle = card && card.getAttribute('data-product-handle');
      var size = option.querySelector('input[data-option-name="Size"]');
      if (!size || !/^(shaw-|henning-)/.test(handle || '')) return;
      var container = option.closest('.bundly__product_details, .bundly__component_info');
      if (container) mountSizeGuide(container, template);
    });
  }

  function updatePrice(record) {
    var current = text(record.details.querySelector('.bundly__bundle_new_price'));
    var original = text(record.details.querySelector('.bundly__bundle_original_price'));
    var currentElement = ensure(record.price, 'message-bundly-current-price', 'span');
    setText(currentElement, current);
    var originalElement = ensure(record.price, 'message-bundly-original-price', 'del');
    setText(originalElement, original);
    originalElement.hidden = !original;
    var badge = ensure(record.price, 'message-bundly-savings', 'span');
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    var amount = savingsAmount(original, current, locale);
    badge.hidden = !amount || !currency;
    if (!badge.hidden) {
      try {
        setText(badge, 'Save ' + new Intl.NumberFormat(locale, {
          style: 'currency', currency: currency, maximumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        }).format(amount));
      } catch (_) { badge.hidden = true; }
    }
  }

  function update(record) {
    if (!record.root.isConnected) {
      record.observer.disconnect();
      records.delete(record);
      return;
    }
    // Our labels live alongside Lit's native controls. Disconnect while writing so
    // our own updates cannot start an observer loop or interfere with its rendering.
    record.observer.disconnect();
    try {
      var slots = readSlots(record);
      var selected = slots.filter(function (slot) { return slot.variantId; });
      var components = Array.from(record.root.querySelectorAll('bundly-collection-component, bundly-product-component'));
      var componentByIndex = new Map(components.map(function (component) {
        // Fixed product components expose component-index without the data alias.
        return [component.getAttribute('data-component-index') || component.getAttribute('component-index'), component];
      }));
      record.root.querySelectorAll('.bundly__add_to_bundle_button').forEach(function (button) {
        var repeated = isRepeatedSelection(slots, {
          componentIndex: button.getAttribute('data-component-index'),
          componentVariantIndex: button.getAttribute('data-component-variant-index'),
          variantId: button.getAttribute('data-variant-id'),
        });
        if (repeated) button.setAttribute('aria-disabled', 'true');
        else button.removeAttribute('aria-disabled');
      });
      selected.forEach(function (slot) {
        var title = slot.element.querySelector('.bundly__slot_title');
        if (!title) return;
        var component = componentByIndex.get(slot.componentIndex);
        slot.element.toggleAttribute('data-message-required', Boolean(component && component.localName === 'bundly-product-component'));
        var note = ensure(title, 'message-bundly-three-pack-note');
        note.hidden = !(/3[ -]?pack/i.test(slot.title) && /fall uniform/i.test(slot.color));
        if (!note.hidden) setText(note, 'Ribbed Chestnut, Persimmon, Slate. All three pairs included.');
      });
      addSizeGuides(record);
      components.forEach(function (component) {
        component.querySelectorAll('.bundly__component_quantity_info').forEach(function (label) {
          label.toggleAttribute('data-message-single-choice', /^Select\s+1$/i.test(text(label)));
        });
        var index = component.getAttribute('data-component-index') || component.getAttribute('component-index');
        var componentSelections = selected.filter(function (slot) { return slot.componentIndex === index; });
        var header = component.querySelector('.bundly__component_header > div');
        if (header) {
          var label = ensure(header, 'message-bundly-component-selection');
          renderHeaderSelection(label, componentSelections, header.parentElement);
        }
        component.querySelectorAll('bundly-collection-component-card, bundly-product-component-card').forEach(function (card) {
          var info = card.querySelector('.bundly__component_info');
          var image = card.querySelector('.bundly__component_image img');
          if (!info) return;
          var selection = card.localName === 'bundly-product-component-card' ? componentSelections.find(function (slot) {
            return slot.variantId === card.getAttribute('data-selected-variant-id') &&
              slot.componentVariantIndex === card.getAttribute('data-component-variant-index');
          }) : selectedProduct({
            productId: card.getAttribute('data-product-id'),
            title: text(card.querySelector('.bundly__component_title')),
            image: image && image.getAttribute('src'),
          }, componentSelections, productByVariant);
          card.toggleAttribute('data-message-selected', Boolean(selection));
          card.toggleAttribute('data-message-selection-color', Boolean(selection && selection.color));
          card.toggleAttribute('data-message-selection-size', Boolean(selection && selection.size));
          if (card.localName === 'bundly-product-component-card') {
            renderIncludedCount(card, selection ? componentSelections.filter(function (slot) {
              return slot.variantId === selection.variantId && slot.componentVariantIndex === card.getAttribute('data-component-variant-index');
            }).length : 0);
            card.querySelectorAll('.bundly__product_option').forEach(function (option) {
              var label = fixedSizeLabel(Boolean(selection), Array.from(option.querySelectorAll('input')).map(function (input) {
                return { name: input.getAttribute('data-option-name') || '', value: input.value };
              }));
              // Keep native inputs intact for Bundly; a fixed selection is information,
              // not an actionable radio control, in both the card and its dialog.
              option.toggleAttribute('data-message-fixed-size', Boolean(label));
              var caption = option.nextElementSibling;
              if (!caption || !caption.classList.contains('message-bundly-fixed-size')) {
                if (!label) return;
                caption = document.createElement('p');
                caption.className = 'message-bundly-fixed-size';
                option.insertAdjacentElement('afterend', caption);
              }
              caption.hidden = !label;
              if (label) setText(caption, label);
            });
          }
          var status = ensure(info, 'message-bundly-card-status');
          renderCardSelection(status, selection);
          var pack = /3[ -]?pack/i.test(text(card.querySelector('.bundly__component_title'))) &&
            /fall uniform/i.test(text(card.querySelector('.bundly__custom_data_metafields')));
          var note = ensure(info, 'message-bundly-three-pack-note');
          note.hidden = !pack;
          if (pack) setText(note, 'Ribbed Chestnut, Persimmon, Slate. All three pairs included.');
          if (card.localName === 'bundly-collection-component-card') {
            // Single-variant collection cards skip the picker, but their native
            // dialog still exposes the actual size option for an informational label.
            mountCardSize(info, Array.from(card.querySelectorAll('.bundly__product_modal input[data-option-name="Size"]')).map(function (input) {
              return { name: input.getAttribute('data-option-name'), value: input.value };
            }));
            placeCardNotes(info);
          }
        });
      });
      record.details.classList.add('bundly__details--visible');
      var progress = selectionProgress(slots);
      var buyButtons = record.details.querySelector('.bundly__buy_buttons');
      if (buyButtons && progress.total) {
        var completion = ensure(buyButtons, 'message-bundly-completion', 'p');
        completion.setAttribute('aria-live', 'polite');
        setText(completion, progress.remaining ?
          progress.remaining + (progress.remaining === 1 ? ' selection left.' : ' selections left.') :
          'Your bundle is ready.');
      }
      updatePrice(record);
    } finally {
      record.observer.observe(record.root, {
        childList: true, subtree: true, characterData: true, attributes: true,
        attributeFilter: ['data-variant-id', 'data-component-expanded', 'src', 'disabled'],
      });
    }
  }

  function schedule(record) {
    if (record.pending) return;
    record.pending = true;
    window.requestAnimationFrame(function () {
      record.pending = false;
      update(record);
    });
  }

  function initialize() {
    document.querySelectorAll('.bundly__information_app_block .bundly__block').forEach(function (root) {
      if (enhanced.has(root)) return;
      var info = root.querySelector('.bundly__info');
      var picker = root.querySelector('.bundly__variant_picker');
      var details = root.querySelector('.bundly__details');
      if (!info || !picker || !details) return;

      var overview = document.createElement('div');
      overview.className = 'message-bundly-overview';
      var description = info.querySelector('.bundly__description');
      var paragraphs = description ? Array.from(description.querySelectorAll(':scope > p')).filter(function (p) { return text(p); }) : [];
      var copy = document.querySelector('template[data-message-bundly-copy]');
      if (copy) {
        overview.appendChild(copy.content.cloneNode(true));
        paragraphs.filter(function (p, index) { return index === 0 || /^Includes\b/i.test(text(p)); }).forEach(function (p) { p.remove(); });
        if (description) description.replaceChildren(document.querySelector('template[data-message-bundly-description]').content.cloneNode(true));
      } else if (paragraphs.length) {
        paragraphs[0].classList.add('message-bundly-intro');
        overview.appendChild(paragraphs[0]);
      }
      var price = document.createElement('div');
      price.className = 'message-bundly-price';
      overview.insertBefore(price, overview.querySelector('.message-bundly-includes'));
      paragraphs.slice(1).filter(function (p) { return !copy && /^Includes\b/i.test(text(p)); }).forEach(function (p) {
        p.classList.add('message-bundly-includes');
        overview.appendChild(p);
      });
      info.insertBefore(overview, picker);
      root.classList.add('message-bundly-compact');
      details.classList.add('bundly__details--visible');
      var record = { root: root, details: details, price: price, pending: false, adding: new Map() };
      record.observer = new MutationObserver(function () { schedule(record); });
      enhanced.set(root, record);
      records.add(record);
      update(record);
    });
    if (records.size && discovery) discovery.disconnect();
  }

  ['bundly:afterAddVariant', 'bundly:afterRemoveVariant', 'bundly:afterLoadBundle'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var detail = event.detail || {};
      if (detail.variantId && detail.productId) productByVariant.set(String(detail.variantId), String(detail.productId));
      initialize();
      records.forEach(schedule);
    });
  });
  document.addEventListener('bundly:beforeAddVariant', function (event) {
    if (event.defaultPrevented) return;
    var source = event.target;
    var root = source && source.closest && source.closest('.message-bundly-compact');
    var record = root && enhanced.get(root);
    if (!record) return;
    var detail = event.detail || {};
    var key = String(detail.componentIndex) + ':' + String(detail.componentVariantIndex);
    var pending = record.adding.get(key);
    if (isRepeatedSelection(readSlots(record), detail) ||
        (pending && pending.variantId === String(detail.variantId) && pending.until > Date.now())) {
      event.preventDefault();
      return;
    }
    record.adding.set(key, { variantId: String(detail.variantId), until: Date.now() + 1500 });
  });
  ['bundly:afterAddVariant', 'bundly:afterRemoveVariant'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var root = event.target && event.target.closest && event.target.closest('.message-bundly-compact');
      var record = root && enhanced.get(root);
      if (record) record.adding.delete(String(event.detail.componentIndex) + ':' + String(event.detail.componentVariantIndex));
    });
  });
  document.addEventListener('bundly:beforeToggleDetails', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('.message-bundly-compact')) event.preventDefault();
  });
  document.addEventListener('shopify:section:load', initialize);
  discovery = new MutationObserver(initialize);
  discovery.observe(document.documentElement, { childList: true, subtree: true });
  initialize();
})();
